const navbarHome = document.querySelector('.navbar-home');

if (navbarHome) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 80) {
      navbarHome.classList.add('navbar-home-toggle');
    } else {
      navbarHome.classList.remove('navbar-home-toggle');
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/navbar.js